<template>
  <!-- 揭西县人民医院 -->
  <div class="pageContent">
    <div class="hosName">银川市口腔医院</div>
    <div class="ourterTitle">
      影像检查数字化报告/影像系统
    </div>
    <div class="bindDetails">
      <div class="IDNumber">
        <van-field
          v-model="value75000001.name75000001"
          placeholder="请输入姓名查询"
        />
      </div>
      <div class="IDNumber">
        <van-field
          v-model="value75000001.value1"
          clearable
          placeholder="请选择就诊时间"
          @focus="showPopup"
        />
        <!-- <van-cell is-link >展示弹出层</van-cell> -->
        <van-popup v-model="show" class="van-Date">
          <van-datetime-picker
            v-model="currentDate"
            type="date"
            @confirm="onConfirm"
            @cancel="onCancel"
          />
        </van-popup>
      </div>
      <footer class="footer">
        <van-button type="primary" :disabled="rules" @click.native="nextFn"
          >下一步</van-button
        >
      </footer>
    </div>
  </div>
</template>
<script>
import { bind, dockCheckCaptcha } from "@/api/login";
import Storage from "@/tools/storage";
export default {
  data() {
    return {
      // name75000001: "",
      value75000001: {
        name75000001: "",
        value1: ""
      },
      rules: true,
      show: false,
      value1: "",
      currentDate: new Date()
    };
  },
  watch: {
    value75000001:{
      handler: function(newVal, oldVal) {
        if (newVal.name75000001 != "" && newVal.value1 != "") {
          this.rules = false;
        } else {
          this.rules = true;
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    showPopup() {
      this.show = true
    },
    onCancel() {
      this.show = false
    },
    onConfirm(value) {
      let date = value
      let month = date.getMonth() + 1
      let strDate = date.getDate()
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate
      }
      this.value75000001.value1 = date.getFullYear() + '' + month + '' + strDate
      this.show = false
    },
    nextFn() {
      let institution_id = window.location.href.split("/checkInfoOuter/")[1];
      window.localStorage.setItem("value75000001", JSON.stringify(this.value75000001));
      window.localStorage.setItem("institution_id", institution_id);
      this.$router.push({
        path: "/reportListOuter",
      });
    },
  },
  created() {
    window.localStorage.clear();
    let institution_id = window.location.href.split("/checkInfoOuter/")[1];
    let value75000001 = JSON.parse(window.localStorage.getItem("value75000001"))
    if (value75000001.value1 != "" && value75000001.name75000001 != "") {
      this.$router.push({
        path: "/reportListOuter",
      });
    }
  },
};
</script>
<style lang="scss" scoped>
.hosName {
  font-size: 30px;
  padding: 65px 0 5px;
  color: rgb(164, 25, 16);
}
.ourterTitle {
  padding: 0 0 20px;
  font-size: 12px;
  color: rgb(51, 62, 80)
}
.bindDetails {
  width: 90%;
  margin: 0 auto;
}
</style>
